<script lang="ts">
  import { cn } from "@/lib/utils";
  import type { XSSDetails } from "@/Util/utils";
  
  export let xss: XSSDetails<string>;
  export let className = 'text-sm font-semibold';
  export let grayscale = false;
</script>

<span class={className}>
  <span>{xss.xss}</span>
  {'('}
  {#if xss.xlss}
    <span class={cn(!grayscale ? "text-[var(--color-xlss)]" : '')}>{xss.xlss}</span>
  {/if}
  {' | '}
  {#if xss.xhss}
    <span class={cn(!grayscale ? "text-[var(--color-xhss)]" : '')}>{xss.xhss}</span>
  {/if}
  {' | '}
  {#if xss.xpss}
    <span class={cn(!grayscale ? "text-[var(--color-xpss)]" : '')}>{xss.xpss}</span>
  {/if}
  {')'}
</span>
